import React from "react";
import "./index.less";
import { useTranslation } from "react-i18next";

export default function Nav() {
    const { i18n, t } = useTranslation();

    const handleLangChange = () => {
        const newLang = i18n.language === "zh" ? "en" : "zh";
        i18n.changeLanguage(newLang);
    };

    return (
        <div className="nav">
            <div className="nav__tertiary">
                <div className="tell">+86 15716377150</div>
                <div className="email">guohaolei@yunchijixie.com</div>
            </div>
            <div className="nav__main">
                <div className="logo-container">
                    <img
                        className="logo"
                        src="http://47.115.148.248:9000/officeweb/office_logo.png"
                        alt="Yunchi Machinery"
                    />
                    <div className="brand-text">
                        <span className="brand-name">河南云螭</span>
                        <span className="brand-slogan">Yunchi Machinery</span>
                    </div>
                </div>
                <ul className="nav__primary">
                    {
                        [
                            { key: "home", content: t('nav.home') },
                            { key: "products", content: t('nav.products') },
                            { key: "about", content: t('nav.about') },
                            { key: "story", content: t('nav.story') },
                        ].map((item) => (
                            <li key={item.key}>
                                <a href={`/${item.key}`}>{item.content}</a>
                            </li>
                        ))
                    }
                </ul>
                <div className="nav__actions">
                    <button className="lang-switch" onClick={handleLangChange}>
                        {i18n.language === "zh" ? "EN" : "中文"}
                    </button>
                    <button className="cta-button">Get Quote</button>
                </div>
            </div>
        </div>
    );
}
